import { Component, OnInit, ViewChild, ElementRef, Renderer2, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { logbaseService } from '../../services/logbase.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-vendor-scheduler',
  templateUrl: './vendor-scheduler.component.html',
  styleUrls: ['./vendor-scheduler.component.scss']
})
export class VendorSchedulerComponent implements OnInit {  
  missingDPData: any;
  missingVSData: any[];
  missingVS: any;
  userIDTaken: boolean;
  missingCode: any;
  editlastNameJap: any;
  editlastName: any;
  editFirstNameJap: any;
  editFirstName: any;
  editVSCode: any;
  loginId: any;
  japLastName: string;
  japFirstName: string;
  engLastName: string;
  engFirstName: string;
  VSCode: any;
  VSCodeList: any;
  searchText: any;
  // @ViewChild(DataTableDirective)
  @ViewChild('createNav') createNav: ElementRef;
  @ViewChild('createPane') createPane: ElementRef;
  @ViewChild('unlistNav') unlistNav: ElementRef;
  @ViewChild('unlistPane') unlistPane: ElementRef;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<any>;
  dtTriggerUnlisted: Subject<any> = new Subject();
  dtTrigger: Subject<any> = new Subject();
  dtOptions: DataTables.Settings[] = [];
  modalRef: NgbModalRef;
  public rows: Array<any> = [];
  public columns: Array<any> 
  public page: number = 1;
  public itemsPerPage: number = 100;
  public maxSize: number = 100;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;

  public config: any
  private data: Array<any> = [];
  srchValue:any;

  constructor(private modalService: NgbModal, private logbaseService: logbaseService, private toaster: ToastrService,
    private renderer: Renderer2, private spinner: NgxSpinnerService, private ref: ChangeDetectorRef, private translate: TranslateService) {
      this.columns= [
        { title: this.translate.instant('VS Code'), name: 'VSCode' },
        { title: this.translate.instant('Unlisted'), name: 'unlisted' },
      ];
      this.config = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table-striped', 'table-bordered']
      };
     }

  ngOnInit() {
    this.dtOptions[0] = {
      pagingType: 'simple_numbers',
      dom: '<"top"<"row"<"col-md-8 text-right"<"#dtpagination"p>><"col-md-4 text-right"<"#dtlength"l>><"clear">>><"#dtSearch_unlistVSCode"f>t<"bottom"<"clear">>',
      language: {
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant("Search by VS Code"),
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $('td', row).unbind('click');
        $('td', row).bind('click', () => { });
        return row;
      }
    };

    this.dtOptions[1] = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      dom: '<"top"<"row"<"col-md-8 text-right"<"#dtpagination"p>><"col-md-4 text-right"<"#dtlength"l>><"clear">>><"#dtSearch_VS"f>t<"bottom"<"clear">>',
      language: {
        emptyTable: this.translate.instant('No Records Found'),
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant('Search by VS Code'),
        "paginate": {
          "first": "First",
          "last": "Last",
          "next": this.translate.instant("Next"),
          "previous": this.translate.instant("Previous")
        },
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
        });
        return row;
      }
    }

    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.loginId = userDetJson.loginId;
    this.spinner.show();
    this.logbaseService.getVSList().subscribe(
      result => {
        this.VSCodeList = result.response;
        this.spinner.hide()
        this.dtTrigger.next(true);
      })
    this.onChangeTable(this.config, true);

  }

  navigateTab(data) {
    const navFirst = this.unlistNav.nativeElement;
    const paneFirst = this.unlistPane.nativeElement;
    const navSecond = this.createNav.nativeElement;
    const paneSecond = this.createPane.nativeElement;
    this.renderer.setAttribute(navFirst, 'class', 'nav-link');
    this.renderer.setAttribute(paneFirst, 'class', 'tab-pane');
    this.renderer.setAttribute(navSecond, 'class', 'nav-link active');
    this.renderer.setAttribute(paneSecond, 'class', 'tab-pane active');
    // Bind delivery point from the clicked item list
    this.VSCode = data.vendorSchedulerCode;
  };

  valuechange(newValue) {
    this.VSCode = newValue;
    if (newValue) {
      if (newValue.length > 0) {
        this.logbaseService.fetchvsdetails(newValue).subscribe(
          data => {
            // set success message and pass true paramater to persist the message after redirecting to the login page
            if (data.response == "Response is empty") {
              document.getElementById("mytext").innerHTML = " ";
              this.userIDTaken = false;
            }
            else {
              document.getElementById("mytext").innerHTML = "User ID Already Taken";
              this.userIDTaken = true;
            }
          },
          error => {
            this.postFormError();
          });;
      }
      else {
        this.userIDTaken = false;
        document.getElementById("mytext").innerHTML = " ";
      }
    }


  }
  postFormError() {
    this.toaster.warning('Problem while Submission, Kindly check your network status');
  }
  addVSUser(f) {
    var VSUserData = {
      vendorSchedulerCode: this.VSCode,
      vendorSchedulerFirstNameEN: this.engFirstName,
      vendorSchedulerLastNameEN: this.engLastName,
      vendorSchedulerFirstNameJP: this.japFirstName,
      vendorSchedulerLastNameJP: this.japLastName,
      createdDate: null,
      createBy: this.loginId,
      updatedDate: null,
      updatedBy: this.loginId
    }

    var updateDate = {
      vendorSchedulerCode: this.VSCode,
      missing: false
    }
    this.spinner.show();
    this.logbaseService.addVSUser(VSUserData).subscribe(
      response => {
        this.logbaseService.updateMissingVS(updateDate).subscribe(
          result => {
            this.toaster.success(this.translate.instant('VSCODE_ADDED_SUCCESS'));
            this.rerender();
            // this.spinner.hide();
            this.modalRef.close();
            f.resetForm();
          })
      })
  }

  editRowDetails(editDetails, data) {
    this.editVSCode = data.vendorSchedulerCode;
    this.editFirstName = data.vendorSchedulerFirstNameEN;
    this.editlastName = data.vendorSchedulerLastNameEN;
    this.editFirstNameJap = data.vendorSchedulerFirstNameJP;
    this.editlastNameJap = data.vendorSchedulerLastNameJP;
    this.modalRef = this.modalService.open(editDetails,{backdrop:false})
    this.modalRef.result.then((result) => {
    });
  }

  saveChanges() {
    this.modalRef.close();
    var dataToSend = {
      vendorSchedulerCode: this.editVSCode,
      vendorSchedulerFirstNameEN: this.editFirstName,
      vendorSchedulerLastNameEN: this.editlastName,
      vendorSchedulerFirstNameJP: this.editFirstNameJap,
      vendorSchedulerLastNameJP: this.editlastNameJap,
      createdDate: null,
      createBy: this.loginId,
      updatedDate: null,
      updatedBy: this.loginId
    }
    this.spinner.show();
    this.logbaseService.editVSUser(dataToSend).subscribe(
      response => {
        this.toaster.success('VS Code ' + this.editVSCode + ' updation successfull')
        this.rerender();
        this.spinner.hide()
      })
  }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  };

  rerender() {
    this.onChangeTable(this.config, true);
    this.logbaseService.getVSList()
      .subscribe(result => {
        this.VSCodeList = result.response;
        // this.dtTrigger.next();
        this.spinner.hide();
      });
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (item[column.name].toString().match(this.config.filtering.filterString)) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    var pageNo;
    var sortData;


    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value.name,
          sort: value.sort
        }
      }
    });
    var dataToSend = {
      pageNum: pageNo,
      // searchValue: this.config.filtering.filterString,
      searchValue:this.srchValue,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
    }

    this.spinner.show();
    this.logbaseService.getMissingVSVodePaginated(dataToSend)
      .subscribe(result => {
        // this.SupplierResult = result
        this.missingVS = result;
        this.missingDPData = this.missingVS.response.content;
        var partArr;
        var partsData = [];

        // this.missingVS.response.content.forEach(function (value, key) {
        //   partArr = {
        //     VSCode: value.vendorSchedulerCode,
        //     unlisted: '<td class="text-center hasLink">' + '<i class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i> ' + 'Add VS Code' + '</td>'
        //   };
        //   partsData.push(partArr);
        // });

        this.missingVSData = partsData;
        this.data = partsData;
        this.length = this.missingVS.response.totalElements;
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        //this.length = sortedData.length;
        this.rerenderTable(this.config, true);
        this.ref.detectChanges();
        this.spinner.hide();
      });
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }

  openModal(VSCode, f) {
    if (f.valid) {
      this.modalRef = this.modalService.open(VSCode, { backdrop: false })
    }
  }
  sanitizeForCSV(value: any): string {
    if (value === null || value === undefined) return '""'; // Empty cell

    let strValue = String(value).trim();

    // Escape all double quotes by doubling them
    strValue = strValue.replace(/"/g, '""');

    // Detect if the value starts with a dangerous character
    if (/^[=+\-@]/.test(strValue)) {
      // Prefix with a single quote to prevent formula execution
      strValue = `'${strValue}`;
    }

    // Wrap everything in double quotes for safety
    return `"${strValue}"`;
  }

  exportCSV() {
    const sanitizedData = this.VSCodeList.map(item => {
      return {
        'VS Code': this.sanitizeForCSV(item.vendorSchedulerCode),
        'First Name[Eng]': this.sanitizeForCSV(item.vendorSchedulerFirstNameEN),
        'Last Name[Eng]': this.sanitizeForCSV(item.vendorSchedulerLastNameEN),
        'First Name[Jap]': this.sanitizeForCSV(item.vendorSchedulerFirstNameJP),
        'Last Name[Jap]': this.sanitizeForCSV(item.vendorSchedulerLastNameJP)
      };
    });
  
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: ['VS Code', 'First Name[Eng]', 'Last Name[Eng]', 'First Name[Jap]', 'Last Name[Jap]']
    };
  
    new AngularCsv(sanitizedData, 'Available VS Code', options);
  }

}

